var render, staticRenderFns
import script from "./btn.vue?vue&type=script&lang=coffee&"
export * from "./btn.vue?vue&type=script&lang=coffee&"
import style0 from "./btn.vue?vue&type=style&index=0&id=45591f88&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45591f88",
  null
  
)

export default component.exports